export interface IPaymentData {
  datetime: string;
  description: string;
  amount: number;
  method: string | null;
  method_type: string | null;
  cardholder_name: string | null;
}

export default class Payment {
  public datetime: string;
  public description: string;
  public amount: number;
  public method: string | null;
  public methodType: string | null;
  public cardholderName: string | null;

  constructor(data: IPaymentData) {
    this.datetime = data.datetime;
    this.description = data.description;
    this.amount = data.amount;
    this.method = data.method;
    this.methodType = data.method_type;
    this.cardholderName = data.cardholder_name;
  }

  toDTO(): IPaymentData {
    return {
      datetime: this.datetime,
      description: this.description,
      amount: this.amount,
      method: this.method,
      method_type: this.methodType,
      cardholder_name: this.cardholderName
    };
  }

  static fromDTO(dto: IPaymentData): Payment {
    return new Payment(dto);
  }

}
